import React, { Component, RefObject } from 'react';

import InlineEdit from '@atlaskit/inline-edit';
import Textfield from '@atlaskit/textfield';

import './_editable-title.scss';

type Props = {
  value: string;
  onConfirm: (value: string) => boolean;
  onChange: (name: string, invalid: boolean) => void;
  onCancel: () => void;
  canEdit: boolean;
  isInvalid: boolean;
  innerRef: RefObject<HTMLDivElement>;
  onIsEditingChange?: (isEditing: boolean) => void;
};

type State = {
  isEditing: boolean;
};

class EditableTitle extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isEditing: false,
    };
  }

  render(): React.ReactNode {
    return (
      <div className='title' ref={this.props.innerRef}>
        {this.state.isEditing ? (
          <div className='input test-case-input-wrapper hide-focus-wrapper'>
            <InlineEdit
              startWithEditViewOpen={this.state.isEditing}
              readViewFitContainerWidth={true}
              defaultValue={this.props.value}
              onEditRequested={this.handleEditRequested}
              isLabelHidden
              onConfirm={this.handleConfirm}
              shouldConfirmOnEnter={true}
              keepEditViewOpenOnBlur={false}
              editView={(fieldProps) => (
                <Textfield className='editView' {...fieldProps} autoFocus />
              )}
              // @ts-expect-error we handle readView ourselves, so there is no need to provide function that returns react component.
              readView={this.handleCancel}
              isInvalid={this.props.isInvalid}
              validate={(value) => this.validate(value)}
              shouldLoadToolbar={false}
            />
            {this.props.isInvalid ? (
              <div className='editable-title-error'>
                Title should have between 1-250 characters.
              </div>
            ) : null}
          </div>
        ) : (
          <h4 className='editable-title' onClick={this.handleEditRequested}>
            {this.props.value}
          </h4>
        )}
      </div>
    );
  }

  handleEditRequested = (): void => {
    if (this.props.canEdit) {
      this.setState({
        isEditing: true,
      });
      this.props.onIsEditingChange?.(true);
    }
  };

  validate = (value: string): undefined | 'error' => {
    const invalid = value.length > 250 || value.length < 1;
    this.props.onChange(value, invalid);

    if (invalid) {
      this.setState({
        isEditing: true,
      });
      return 'error';
    }
    return undefined;
  };

  handleConfirm = (value: string): void => {
    const success = this.props.onConfirm(value);
    if (success) {
      this.setState({
        isEditing: false,
      });
    }
    this.props.onIsEditingChange?.(false);
  };

  handleCancel = (): void => {
    this.setState({
      isEditing: false,
    });
    this.props.onCancel();
    this.props.onIsEditingChange?.(false);
  };
}

export default EditableTitle;
